import { graphql } from '../../../gql';

export const MY_PENDING_REWRITE_POSTS_QUERY = graphql(`
  query myPendingRewritePosts {
    myPendingRewritePosts {
      id
      status
      createdAt
      textBlocks {
        ...TextBlockFields
      }
      moderation {
        ...PostModerationMetaFields
      }
    }
  }
`);
